import { cssJoin } from '@volvo-cars/css/utils';

import styles from './Tag.module.css';

type TagColor = 'default' | 'blue' | 'green';

type TagSize = 'large' | 'small';

const Tag: React.FC<{
  children: string;
  color?: TagColor;
  size?: TagSize;
}> = ({ children, color = 'default', size = 'small' }) => (
  <span className={cssJoin('micro', styles.tag, styles[color], styles[size])}>
    {children}
  </span>
);

export default Tag;
